import { apiClient } from "@/lib/api-client";
import {
  GetOrganizationUsersResponse,
  GetOrganizationRolesResponse,
  UpdateUserRequest,
  AddUserRequest,
  AssignUserRoleRequest,
  AddOrganizationUserResponse,
} from "../dtos/User";

export const userService = {
  getOrganizationUsers: async (organizationId: string) => {
    const response = await apiClient.get<GetOrganizationUsersResponse>(
      `/organizations/${organizationId}/users`
    );
    return response.data;
  },

  getOrganizationRoles: async (organizationId: string) => {
    const response = await apiClient.get<GetOrganizationRolesResponse>(
      `/organizations/${organizationId}/roles`
    );
    return response.data;
  },

  addOrganizationUser: async (organizationId: string, data: AddUserRequest) => {
    const response = await apiClient.post<AddOrganizationUserResponse>(
      `/organizations/${organizationId}/users`,
      data
    );
    return response.data;
  },

  updateOrganizationUser: async (organizationId: string, userId: string, data: UpdateUserRequest) => {
    const response = await apiClient.put(
      `/organizations/${organizationId}/users/${userId}`,
      data
    );
    return response.data;
  },

  assignUserRole: async (organizationId: string, userId: string, data: AssignUserRoleRequest) => {
    const response = await apiClient.put(
      `/organizations/${organizationId}/users/${userId}/role`,
      data
    );
    return response.data;
  },

  removeOrganizationUser: async (organizationId: string, userId: string) => {
    const response = await apiClient.delete(
      `/organizations/${organizationId}/users/${userId}`
    );
    return response.data;
  },
};
